export default {
  salesLead: '/dashboard/sales-lead',
};
